/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';

export class ActionEvent {
  public type: 'click' | 'input' | 'select' | 'close';
  public action: SimpleAction<any>;
  public value: any;
  public event: MouseEvent;

  constructor(
    type: 'click' | 'input' | 'select' | 'close',
    action: SimpleAction<any>,
    value?: any,
    event?: MouseEvent,
  ) {
    this.type = type;
    this.action = action;
    this.value = value;
    this.event = event;
  }
}
